import { render, staticRenderFns } from "./PCDashboard.vue?vue&type=template&id=6a2209c1&"
import script from "./PCDashboard.vue?vue&type=script&lang=js&"
export * from "./PCDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VContainer,VRow,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a2209c1')) {
      api.createRecord('6a2209c1', component.options)
    } else {
      api.reload('6a2209c1', component.options)
    }
    module.hot.accept("./PCDashboard.vue?vue&type=template&id=6a2209c1&", function () {
      api.rerender('6a2209c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/PCDashboard.vue"
export default component.exports